/*eslint max-lines-per-function: ["error", 297]*/
/*eslint complexity: ["error", 75]*/
import React from 'react';

import {
  CreateUpdateEstimateItemDto,
  GetPositionDto,
  GetProfileDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import CurrencyControl from '../../../app/components/CurrencyControl';

import { isFieldHidden } from './CommissionService';
import ProfileFieldName from './ProfileFieldName';

interface SalesParamsProps {
  estimateItem: CreateUpdateEstimateItemDto;
  profile?: GetProfileDto;
  position?: GetPositionDto;
  readonly?: boolean;
  lang: string;
  propertyChange?: (obj: Partial<CreateUpdateEstimateItemDto>) => void;
}

export const SalesParams: React.FC<SalesParamsProps> = props => {
  const schema = props.profile?.schema;

  const propertyChange = (obj: Partial<CreateUpdateEstimateItemDto>) => {
    if (props.propertyChange) {
      props.propertyChange(obj);
    }
  };

  return (
    <>
      {schema?.rcSalesTotal &&
        !isFieldHidden(
          'rcSalesTotal',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="rcSalesTotal"
            schema={schema.rcSalesTotal}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.rcSalesTotal}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  rcSalesTotal: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesSurchargePercent &&
        !isFieldHidden(
          'salesSurchargePercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesSurchargePercent"
            schema={schema?.salesSurchargePercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesSurchargePercent}
              percentage={true}
              decimalScale={20}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesSurchargePercent: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesDiscountPercent &&
        !isFieldHidden(
          'salesDiscountPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesDiscountPercent"
            schema={schema?.salesDiscountPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesDiscountPercent}
              percentage={true}
              max={100}
              decimalScale={20}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesDiscountPercent: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesNet &&
        !isFieldHidden(
          'salesNet',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesNet"
            schema={schema?.salesNet}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesNet}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesNet: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesCommissionPercent &&
        !isFieldHidden(
          'salesCommissionPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesCommissionPercent"
            schema={schema?.salesCommissionPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesCommissionPercent || ''}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesCommissionPercent: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesCommissionAmount &&
        !isFieldHidden(
          'salesCommissionAmount',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesCommissionAmount"
            schema={schema?.salesCommissionAmount}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesCommissionAmount || ''}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesCommissionAmount: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesNetTechnicalCost &&
        !isFieldHidden(
          'salesNetTechnicalCost',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesNetTechnicalCost"
            schema={schema?.salesNetTechnicalCost}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesNetTechnicalCost}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesNetTechnicalCost: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesBeerTax &&
        !isFieldHidden(
          'salesBeerTax',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesBeerTax"
            schema={schema?.salesBeerTax}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesBeerTax}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesBeerTax: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesPrintingCosts &&
        !isFieldHidden(
          'salesPrintingCosts',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesPrintingCosts"
            schema={schema?.salesPrintingCosts}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesPrintingCosts}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesPrintingCosts: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesOperatingFee &&
        !isFieldHidden(
          'salesOperatingFee',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesOperatingFee"
            schema={schema?.salesOperatingFee}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesOperatingFee}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesOperatingFee: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesBlockSurcharge &&
        !isFieldHidden(
          'salesBlockSurcharge',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesBlockSurcharge"
            schema={schema?.salesBlockSurcharge}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesBlockSurcharge}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesBlockSurcharge: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
      {schema?.salesTransferCosts &&
        !isFieldHidden(
          'salesTransferCosts',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="salesTransferCosts"
            schema={schema?.salesTransferCosts}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.salesTransferCosts}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  salesTransferCosts: value,
                })
              }
              allowNegative
            />
          </ProfileFieldName>
        )}
    </>
  );
};
